import React from 'react';
import { Sticker } from './Sticker';
import { Marquee } from './Marquee';
export function CtaBanner() {
  return <section className="relative overflow-hidden border-y-8 border-otter-black bg-otter-cyan py-24" data-id="element-152">
      <div className="absolute inset-0 bg-halftone bg-halftone-size opacity-20" data-id="element-153" />

      <div className="container relative z-10 mx-auto px-4 text-center" data-id="element-154">
        <Sticker rotation={-15} className="absolute left-10 top-10 hidden md:flex" data-id="element-155">
          <span className="text-2xl" data-id="element-156">🔥</span>
        </Sticker>
        <Sticker rotation={10} className="absolute bottom-10 right-10 hidden bg-otter-bone md:flex" data-id="element-157">
          <span className="text-2xl" data-id="element-158">✨</span>
        </Sticker>

        <h2 className="mx-auto max-w-4xl font-display text-[4rem] leading-none tracking-tighter text-otter-black sm:text-[6rem] lg:text-[8rem]" data-id="element-159">
          READY TO STOP COOKING ON GRIME?
        </h2>

        <a href="#contact" className="mx-auto mt-12 inline-block border-4 border-otter-black bg-otter-black px-12 py-6 font-display text-4xl tracking-widest text-otter-cyan transition-transform hover:scale-105 hover:shadow-brutal" data-id="element-160">
          BOOK NOW
        </a>
      </div>

      <div className="absolute bottom-0 w-full border-t-4 border-otter-black bg-otter-bone py-2" data-id="element-161">
        <Marquee text="LET'S GET SCRUBBING • LET'S GET SCRUBBING •" speed={15} className="font-display text-2xl text-otter-black" data-id="element-162" />
      </div>
    </section>;
}